.feature-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-8) var(--space-16);
  box-shadow: inset 0 -1px 0 0 var(--grey-300);

  &.hide-row-divider {
    box-shadow: none;
  }

  &.is-last-row-in-section {
    padding-bottom: var(--space-32);
  }

  &.is-current-plan-column {
    background-color: var(--gray-F9FAFB);
  }

  &.is-selected-plan-column {
    background-color: var(--blue-EDF6FF);
    box-shadow:
      inset 2px 0 0 0 var(--blue-1D5AD8),
      inset -2px 0 0 0 var(--blue-1D5AD8),
      inset 0 -1px 0 0 var(--grey-300);

    &.hide-row-divider {
      box-shadow:
        inset 2px 0 0 0 var(--blue-1D5AD8),
        inset -2px 0 0 0 var(--blue-1D5AD8);
    }

    &.is-last-row-in-column {
      border-radius: 0 0 4px 4px;
      box-shadow:
        inset 2px 0 0 0 var(--blue-1D5AD8),
        inset -2px 0 0 0 var(--blue-1D5AD8),
        inset 0 -2px 0 0 var(--blue-1D5AD8);
    }
  }
}
